import React, { useState } from 'react';
import './index.css';
import CustomModal from '../CustomModal';
import Cart from './components/Cart';

const CartPopUp = ({ closeFunc, closeFuncState, fetchCartList }) => {

  return (
    <CustomModal closeFunc={closeFunc} closeFuncState={closeFuncState} cartPopUp offOutSideClick disableBackGroundScroll >
      <Cart fetchCartList={fetchCartList} closeFuncState={closeFuncState} />
    </CustomModal>
  );
};

export default CartPopUp;
